export const primeNGTranslation = {
  startsWith: 'Comienza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual',
  notEquals: 'No igual',
  noFilter: 'Sin filtros',
  lt: 'Menor a',
  lte: 'Menor o igual a',
  gt: 'Mayor a',
  gte: 'Mayor o igual a',
  is: 'Es',
  isNot: 'No es',
  before: 'Antes',
  after: 'Después',
  clear: 'Limpiar',
  apply: 'Aceptar',
  matchAll: 'Aplicar a todo',
  matchAny: 'Aplicar a solo una parte',
  addRule: 'Agregar regla',
  removeRule: 'Eliminar regla',
  accept: 'Si',
  reject: 'No',
  choose: 'Elegir',
  upload: 'Subir',
  cancel: 'Cancelar',
  dayNames: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Setiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Oct',
    'Nov',
    'Dec',
  ],
  today: 'Hoy',
  weekHeader: 'Semana',
  weak: 'Débil',
  medium: 'Medio',
  strong: 'Fuerte',
  passwordPrompt: 'Ingrese una contraseña',
  emptyMessage: 'No se encontraron resultados',
  emptyFilterMessage: 'No se encontraron resultados',
  dateFrom: 'Fecha desde',
  dateTo: 'Fecha hasta',
  monthFrom: 'Mes desde',
  monthTo: 'Mes hasta',
  monthIs: 'Mes igual',
  dateIs: 'Fecha igual',
  selectionMessage: '{0} items seleccionados',
};
